import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnBoardingService } from '../../../../../api-services/onboarding.service';
import { UserInternalNotes } from '../../../../../models/onboarding/user-internal-notes.model';
import { SharedService } from '../../../../../services';
import { AlertService } from '../../../../shared-component/alert-dialog/alert.service';

@Component({
  selector: 'app-onboarding-notes',
  templateUrl: './onboarding-notes.component.html',
  styleUrls: ['./onboarding-notes.component.css']
})
export class OnboardingNotesComponent implements OnInit {

  @Input() userId;
  //@Output() getUserInternalNotesCountEvent = new EventEmitter<number>();
  @Output() closeSideNotes: any = new EventEmitter();
  @Input() isOnboardingDasboard: boolean = false;
  @Input() className: string = '';
  @Input() currentPage: boolean;
  
  userInternalNotes: UserInternalNotes[] = [] as UserInternalNotes[];
  userInternalNoteForm: FormGroup;
  isDataFound:boolean=false;

  constructor(private sharedService: SharedService, private fb: FormBuilder, private onBoardingService: OnBoardingService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.userInternalNoteForm = this.fb.group({
      memo: ['', [Validators.required, Validators.maxLength(500)]]
    });
    // this.getuserLicenseNotes();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
    this.getUserInternalNotes();
  }

  getUserInternalNotes() {
    this.onBoardingService.getUserInternalNotes(this.userId).subscribe((response: UserInternalNotes[]) => {
      this.isDataFound=true;
      if (response) {
        this.userInternalNotes = response.map(el => ({
          ...el,
          // userNote: el.userNote.replace(/\s+/g, ' ').trim(),
          createdOn: this.sharedService.convertUTCTimeToLocalTime(el.createdOn)
        }))
        this.userInternalNotes = [...this.userInternalNotes];
      }
      //this.getUserInternalNotesCountEvent.emit(this.userInternalNotes.length || 0);
      //this.onBoardingService.setUserInternalNotesCount(this.onboardingUsersId, this.userInternalNotes.length);
    });
  }

  get isMemoValid(): boolean {
    return !!(this.userInternalNoteForm?.get('memo')?.value || '').trim();
  }

  insertUserInternalNote() {
    if (this.userInternalNoteForm.valid) {
      const payload = {
        userId: this.userId,
        userNote: this.userInternalNoteForm.get('memo').value
      }
      this.onBoardingService.insertUserInternalNote(payload).subscribe(
        (response) => {
          if (response && response > 0) {
            this.getUserInternalNotes();
            this.userInternalNoteForm.reset({
              memo: ''
            });
          }
          else {
            this.alertService.error("Oops! Something went wrong. Please try again.");
          }
        },
        (error) => {
          if (error && error.message != undefined) {
            this.alertService.error(error.message);
          }
          else {
            this.alertService.error("Oops! Something went wrong. Please try again.");
          }
        }
      );
    } 
  }

  close(action){
    this.closeSideNotes.emit(action);
  }
}
